<template>
  <b-form novalidate>
    <b-form-group id="input-country" label="Krajina:" label-for="country-select">
      <country-select id="country-select" v-model="contractor.country"></country-select>
    </b-form-group>
    
    <b-form-group v-if="showRpoBox" id="input-group-organization" label="Organizácia:" label-for="rpo-search">
      <rpo-search-box v-if="slovakRpo" id="rpo-search" v-model="contractor.organization"></rpo-search-box>
      <czech-rpo-search-box  v-if="czechRpo" id="czech-rpo-search" v-model="contractor.organization"></czech-rpo-search-box>
    </b-form-group>
    
    <b-form-group v-else id="input-group-foreign-cin" label="Ičo: " label-for="input-foreign-cin">
      <b-form-input id="input-foreign-cin" v-model="contractor.foreignCin" type="text" required placeholder="Zadajte ičo" />
    </b-form-group>
      <b-button variant="success" size="lg" class="pull-right" @click.prevent="selectContractor()">Vybrať</b-button>
  </b-form>
</template>

<script>
import CountrySelect from "@/components/Custom/CountrySelect"
import RpoSearchBox from '@/components/Custom/RpoSearchBox.vue'
import CzechRpoSearchBox from '@/components/Custom/CzechRpoSearchBox.vue'

export default {
  name: "AddContractorWIndow",
  components: { RpoSearchBox, CountrySelect, CzechRpoSearchBox },
  props: ['offerIndex', 'isGroup', 'isMainContractor'],
  data () {
    return {
      contractor: {
        country: {
          code: 'SK',
          text: 'Sloveská Republika'
        },
        organization: null,
        foreignCin: null
      }
    }
  },
  computed: {
    showRpoBox () {
      return this.slovakRpo || this.czechRpo
    },
    slovakRpo () {
      return this.contractor.country === 'SK'
    },
    czechRpo () {
      return this.contractor.country === 'CZ'
    }
  },
  methods: {
    selectContractor () {

      if ((this.contractor.country === 'SK' || this.contractor.country === 'CZ') && !this.contractor.organization.cin) {
        return
      }
      if ((this.contractor.country !== 'SK' &&  this.contractor.country !== 'CZ') && !this.contractor.foreignCin) {
        return
      }

      this.$vuedals.close({
        isGroup: this.isGroup,
        isMainContractor: this.isMainContractor,
        offerIndex: this.offerIndex,
        contractor: this.contractor
      })
    }
  }
}
</script>